var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader-files"},[_vm._t("default",[_c('ul',_vm._l((_vm.files),function(file){return _c('li',{key:file.id},[_c('uploader-file',{attrs:{"file":file,"isPause":_vm.isPause}})],1)}))],{files:_vm.files})],2)}
var staticRenderFns = []

export { render, staticRenderFns }